import { BaseEntity, ObjType } from "./BaseEntity";

/** 契約ステータス */
export const CONTRACT_STATUS: ObjType = {
  "0": "解約済み",
  "1": "契約中",
  "2": "契約超過",
};

/**
 * 利用者(device_user)
 */
export class DeviceUser extends BaseEntity {
  /** 利用者ID */
  public id: string = "";
  /** 利用者名 */
  public userName: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 住所 */
  public address: string = "";
  /** 電話番号 */
  public telNumber: string = "";
  /** メールアドレス */
  public email: string = "";
  /** 契約ステータス */
  public contractStatus: string = "";
  /** 契約期間（開始日） */
  public contractStart: Date = new Date();
  /** 契約期間（終了日） */
  public contractEnd: Date = new Date();
  /** 通信プラン */
  public communicationPlan: string = "";
  /** 料金 */
  public communicationFee: string = "";
  /** コメント */
  public comment: string = "";
}
